import { render, staticRenderFns } from "./UniversalSearchWidget.vue?vue&type=template&id=2bf1e50c"
import script from "./UniversalSearchWidget.vue?vue&type=script&lang=js"
export * from "./UniversalSearchWidget.vue?vue&type=script&lang=js"
import style0 from "./UniversalSearchWidget.vue?vue&type=style&index=0&id=2bf1e50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports